
import { Component, Vue } from 'vue-property-decorator'
import DetailDialog from './DetailDialog.vue'
import { ownModelRating } from '@/utils/dictionary'
import { Form } from 'element-ui'
import http from '@/utils/request'
import { getUserInfo } from '@/utils/user'
import i18n from '@/lang'

@Component({
  components: {
    'app-detail-dialog': DetailDialog
  }
})
export default class extends Vue {
  private list: any[] = []
  private listLoading = true
  private listTotal = 0
  private listQuery = {
    current: 1,
    size: 10,
    //
    isBuy: 0,
    cameraId: '',
    tradeStartTime: '',
    tradeEndTime: '',
    idNo: '',
    riskLevel: '',
    amount: '',
    createTimeStar: '',
    createTimeEnd: '',
    // TODO ???
    lendTime: '',
    loanTime: '',
    loanAmount: ''
  }

  ids = ''
  importanceOptions = [1, 2, 3]
  showDetail = false
  currentRowData: any = {}
  riskLevelList = ownModelRating
  selectedRow = []

  created() {
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    this.initialize().finally(() => (this.listLoading = false))
  }

  //  Tabular data source
  async initialize() {
    return http.post('/lend/list', this.listQuery).then((data) => {
      this.list = data.records
      this.listTotal = data.total
    })
  }

  //  table check
  tableSelect(selection: any) {
    this.selectedRow = selection
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val
    this.getList()
  }

  handleCurrentChange(val: number) {
    this.listQuery.current = val
    this.getList()
  }

  view(row: any) {
    this.$router.push({
      path: '/dashboard/bid-details',
      query: { lid: row.lid, qoalaStatus: row.qoalaStatus, cameraId: row.cameraId }
    })
  }

  // Inquire
  onSearch() {
    this.initialize()
  }

  //  Clear
  onReset() {
    // eslint-disable-next-line
    ;(this.$refs.filtersRef as Form).resetFields()
  }

  // Confirm submission
  onConfirm() {
    this.$confirm(i18n.t('Konfimr untuk asuransi investasi') as string, i18n.t('Peringatan') as string).then(() => {
      const lids = this.selectedRow.map((item: any) => item.lid)
      const { mid: customerId } = getUserInfo('userInfoMap')
      http.post('/lend/doPush', { lids, customerId }).then((data) => {
        if (data) {
          // Sent successfully
          this.$message.success(i18n.t('Berhasil dikirim') as string)
          this.initialize()
        } else {
          // Request failed
          this.$message.error(i18n.t('Permintaan gagal') as string)
        }
      })
    })
  }

  //  Cancel
  onCancel() {
    this.$confirm(i18n.t('Silahkan pilih') as string, i18n.t('Informasi') as string)
      .then(() => {
        /** Confirm acton */
        // console.log()
      })
      .catch(() => {
        /** Cancel action */
      })
  }
}
